import React from "react";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import MenuIcon from "@mui/icons-material/Menu";
import logo from "../../assets/images/logo.png";
import AClogo from "../../assets/images/ac_logo.svg";
import ClearIcon from "@mui/icons-material/Clear";
import { useTheme } from "@emotion/react";
import { Link } from "react-router-dom";
import { Divider, Drawer, IconButton, useMediaQuery } from "@mui/material";
import { useSelector } from "react-redux";
import { ROLES, CHECKROLE } from "../../utils/constants";

const Navbar = ({ handleChange }) => {
  const theme = useTheme();

  const isMobile = useMediaQuery((theme) =>
    theme.breakpoints.between("sm", "md")
  );
  const isTablet = useMediaQuery((theme) =>
    theme.breakpoints.between("md", "lg")
  );

  const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);

  const state = useSelector(
    ({
      seller: {
        msal: { user, roles },
      },
    }) => ({ user, roles })
  );
  
  const handleDrawerOpen = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  return (
    <div>
      {/* <Box sx={{ flexGrow: 2}}/>
      <AppBar position="static" sx={{backgroundColor:'white',color:'black' }}/>
        <Toolbar>
          
          <PersonIcon/>
          <Button color="inherit">Login</Button>
          {/* <Button color="inherit" onClick={()=>setStatus(true)}>{name ? name : "login"}
          </Button> */}
      {/* <Typography variant="h6" component="div" sx={{ flexGrow: 1 }} style={{textAlign:'right'}}>
           <img src={image} style={{maxWidth:20}} alt="loading"
           ></img>    NDC
          </Typography>
          </Toolbar>
          <AppBar/> */}

      <Box>
        <AppBar
          position="fixed"
          sx={{
            backgroundColor: theme.palette.navbarBg,
            color: theme.palette.primary.contrastText,
            flexGrow: 1,
            zIndex: 13002,
            height: "80px",
          }}
        >
          <Toolbar sx={{ height: "inherit" }}>
            {(isMobile || isTablet) && (
              <>
                <IconButton onClick={handleDrawerOpen}>
                  <MenuIcon
                    sx={{
                      ml: -1,
                      pr: 1,
                      color: theme.palette.primary.contrastText,
                    }}
                    fontSize="medium"
                  />
                </IconButton>
                <Drawer
                  open={isDrawerOpen}
                  PaperProps={{
                    sx: { width: "100%", top: "4rem" },
                  }}
                  onClose={() => setIsDrawerOpen(false)}
                >
                  <Box sx={{ display: "flex", ml: 4, pt: "2rem", pb: "1rem" }}>
                    <IconButton
                      sx={{ mr: 2 }}
                      onClick={() => setIsDrawerOpen(false)}
                    >
                      <ClearIcon fontSize="large" />
                    </IconButton>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                      }}
                      onClick={() => window.location.reload()}
                    >
                      <img
                        style={{ height: "1.875rem" }}
                        src={AClogo}
                        alt="logo"
                      />
                    </Box>
                  </Box>
                  <Divider
                    variant="middle"
                    sx={{ borderColor: theme.palette.dividerBorder }}
                  />
                  <Typography
                    variant="h5"
                    sx={{
                      my: 2,
                      ml: 2,
                      fontWeight: "bold",
                      fontSize: "1rem",
                      lineHeight: "1.5rem",
                    }}
                  >
                    {state?.user}
                  </Typography>
                  <Typography
                    onClick={() => window.location.reload()}
                    variant="h5"
                    sx={{
                      cursor: "pointer",
                      my: 2,
                      ml: 2,
                      fontWeight: "bold",
                      fontSize: "1rem",
                      lineHeight: "1.5rem",
                    }}
                  >
                    Seller List
                  </Typography>
                  <Typography
                    onClick={() => handleChange("1")}
                    variant="h5"
                    sx={{
                      cursor: "pointer",
                      my: 2,
                      ml: 2,
                      fontWeight: "bold",
                      fontSize: "1rem",
                      lineHeight: "1.5rem",
                    }}
                  >
                    Sub-Seller List
                  </Typography>
                  {state.roles.some(
                    (role) =>
                      role === CHECKROLE.SUPPORT_ADMIN ||
                      role === CHECKROLE.SUPPORT_USER ||
                      role === ROLES.SUPER_ADMIN
                  ) ? (
                    <Typography
                      onClick={() => handleChange("2")}
                      variant="h5"
                      sx={{
                        cursor: "pointer",
                        my: 2,
                        ml: 2,
                        fontWeight: "bold",
                        fontSize: "1rem",
                        lineHeight: "1.5rem",
                      }}
                    >
                      Payment Catalogue
                    </Typography>
                  ) : null}
                  {state.roles.some((role) => role === ROLES.SUPER_ADMIN) ? (
                    <Typography
                      onClick={() => handleChange("3")}
                      variant="h5"
                      sx={{
                        cursor: "pointer",
                        my: 2,
                        ml: 2,
                        fontWeight: "bold",
                        fontSize: "1rem",
                        lineHeight: "1.5rem",
                      }}
                    >
                      Manage Users
                    </Typography>
                  ) : null}
                  <Divider
                    variant="middle"
                    sx={{ borderColor: theme.palette.dividerBorder }}
                  />
                </Drawer>
              </>
            )}
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                flex: 1,
              }}
            >
              <Link
                to={"/"}
                style={{
                  textDecoration: "none",
                  display: "flex",
                }}
              >
                <img
                  style={{ height: isMobile || isTablet ? "20px" : "inherit" }}
                  src={logo}
                  alt="logo"
                ></img>{" "}
              </Link>
              &nbsp; &nbsp;
              <Divider
                flexItem
                variant="middle"
                sx={{ borderColor: theme.palette.primary.contrastText, my: 0 }}
                orientation="vertical"
              />
              <Typography
                variant="h6"
                letterSpacing={"0.1875rem"}
                lineHeight={"1.9575rem"}
                fontWeight={"400"}
                fontSize={isMobile || isTablet ? "1rem" : "1.25rem"}
              >
                &nbsp; NDC
              </Typography>
            </Box>
            {!(isMobile || isTablet) && (
              <Typography sx={{ fontSize: ".875rem" }} textAlign={"end"}>
                {state.user}
              </Typography>
            )}

            {/* <Button color="inherit" onClick={()=>setStatus(true)}>{name ? name : "login"}
          </Button> */}
          </Toolbar>
        </AppBar>
      </Box>
    </div>
  );
};

export default Navbar;
